<template>
  <div class="edit-view-crossproject" v-loading="loading">
    <el-form class="my-form" ref="form" :hide-required-asterisk="false" :model="fromData" label-position="top" :inline-message="true">
      <el-form-item label="项目标题" prop="title">
        <el-input class="input-style has-color" v-model="fromData.project_name" size="small" placeholder="请输入项目名称">
          <template slot="prefix">
            <ColorControl :dataset="fromData" @change="colorChange" :defaultText="fromData.project_name"></ColorControl>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item label="项目描述" prop="content">
        <el-input type="textarea" size="small" :rows="8" placeholder="请输入项目描述" v-model="fromData.project_overview"></el-input>
      </el-form-item>
    </el-form>
    <el-row>
      <el-col :span="24">
        <wf-button size="small" type="primary" @click="save" auto class="save-btn">保存设置</wf-button>
      </el-col>
    </el-row>
    <el-row class="tool-item first-child">
      <div class="edit-title">冻结项目</div>
      <el-col :span="24" class="edit-conten">冻结该项目后，将暂停项目内的所有编辑功能。你可以重新激活将项目恢复正常。</el-col>
      <el-col :span="24" class="edit-btn">
        <wf-button @click="handleFn(2)" plain size="small" type="primary" auto>了解，冻结项目</wf-button>
      </el-col>
    </el-row>
    <el-row class="tool-item" :gutter="10">
      <div class="edit-title">归档项目</div>
      <el-col :span="24" class="edit-conten">归档项目后，将不再出现在项目工作台中。你可以重新激活将项目恢复正常</el-col>
      <el-col :span="24" class="edit-btn">
        <wf-button @click="handleFn(3)" plain size="small" type="primary" auto>了解，归档项目</wf-button>
      </el-col>
    </el-row>
    <el-row class="tool-item" v-if="isBoss || isCeartor || $permission('项目管理-删除项目')">
      <div class="edit-title">删除项目</div>
      <el-col :span="24" class="edit-conten">删除项目后，所有内容将被抹去，请谨慎操作。</el-col>
      <el-col :span="24" class="edit-btn">
        <wf-button @click="handleFn(4)" plain size="small" type="danger" auto>了解，删除该项目</wf-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
//api
import api from '@/services/api/home/home'
import { mapActions, mapMutations } from 'vuex'
import ColorControl from '@/components/colorControl'
import projectApi from '@/services/api/project/project'
export default {
  props: {
    id: {
      type: Number,
      default: null
    },
    editVisible: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ColorControl
  },
  data() {
    return {
      projectName: '',
      project_list_id: null,
      content: '',
      loading: false,
      projectFoderList: [],
      fromData: {
        default_view: '1'
      },
    }
  },
  watch: {
    editVisible: {
      handler: function (val) {
        if (val) {
          this.init() //获取详情
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions('home/home', ['getNumberOfCrossProjects']),
    ...mapMutations('cross/cross', ['SET_ACTIVE']),
    //初始化获取详情
    async init() {
      this.loading = true
      const res = await api.readCrossProjects({ id: this.id })
      if (res) {
        this.fromData = res
        this.loading = false
      }
    },
    //保存设置
    async save() {
      const param = {
        id: this.fromData.id,
        project_name: this.fromData.project_name,
        project_overview: this.fromData.project_overview,
      }
      const res = await api.updateCrossProjects(param)
      if (res) {
        this.$message({
          message: '保存设置成功',
          type: 'success'
        })
        this.$emit('update')
      }
    },
    //冻结、归档、删除操作
    handleFn(type) {
      let msg = ''
      let title = ''
      switch (type) {
        case 2: //冻结
          msg = '冻结该项目后，将暂停项目内的所有编辑功能。你可以重新激活将项目恢复正常。是否继续?'
          title = '冻结项目'
          break
        case 3: //归档
          msg = '项目归档后,将不会出现在工作台中,可以重新激活将项目恢复正常, 是否继续?'
          title = '归档项目'
          break
        case 4: //删除
          msg = '删除项目后，所有内容将被抹去，请谨慎操作, 是否继续?'
          title = '删除项目'
          break
      }
      this.$wfAlert('warning', title , msg, '确定').then(async () => {
        const param = {
          id: this.id,
          project_status: type
        }
        const res = await api.changeCrossProjectsStatus(param)
        if (res) {
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.getNumberOfCrossProjects()
          this.SET_ACTIVE('2')
          this.$router.replace('/main/myProject/crossProject')
        }
      }).catch(() => {
        console.log('执行异常')
        next(false)
      })
    },
    async colorChange(val) {
      let {background_color, background_text, id} = val
      await projectApi.updateCrossProjectsBackground({id,background_color ,background_text})
      this.fromData.background_color = background_color
      this.fromData.background_text = background_text
      this.$emit('colorChange')
    }
  }
}
</script>
<style lang="scss">
.edit-view-crossproject {
  .el-form-item {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 16px;
    }
  }
  .el-form-item__label {
    padding: 0;
    line-height: 20px;
    margin-bottom: 8px;
  }
  .tool-item {
    margin-bottom: 16px;
    font-size: 14px;
    &.first-child {
      margin-top: 5px;
    }
  }
  .edit-title {
    font-size: 16px;
    line-height: 20px;
    margin: 32px 0 8px;
    font-weight: 600;
  }
  .color-red {
    color: #f56c6c;
  }
  .edit-conten {
    font-size: 14px;
    line-height: 20px;
    color: initial;
    opacity: 0.4;
  }
  .edit-btn {
    margin-top: 16px;
    .el-button {
      width: 242px;
      height: 32px;
    }
  }
  .my-form {
    .el-form-item .el-input__prefix .color-control .el-dropdown .el-dropdown-link img {
      width: 20px;
      height: 20px;
      border-radius: 4px;
    }
    .el-form-item .has-color .el-input__inner {
      padding-left: 70px;
    }
    .el-form-item .color-control {
      border-right: 1px solid rgba(32, 32, 32, 0.16);
      padding-right: 8px;
      height: 100%;
      .el-dropdown {
        display: flex;
        align-items: center;
        height: 100%;
      }
    }
    .el-form-item .el-input__prefix {
      left: 8px;
    }
  }
}
</style>
